(() => {
  'use strict';
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .07, rootMargin: '0px 0px 50px 0px' });
    const hellutiniObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          hellutiniObserver.unobserve(entry.target);
        }
      });
    }, {threshold: .01, rootMargin: '0px 0px 260px 0px'});
    reveals.forEach(element => {
      if(element.matches('.v5-catalogue--watches .v5-catalogue__gallery > .v5-catalogue__piece')){
        hellutiniObserver.observe(element);
      } else {
        observer.observe(element);
      }
    });
  } else {
    reveals.forEach(element => element.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-sort]').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });

  document.querySelectorAll('[data-mobile-menu]').forEach(details => {
    details.querySelectorAll('nav a').forEach(link => {
      link.addEventListener('click', () => { details.open = false; });
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', event => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });
  });

  const formatMoney = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NOK';
    const locale = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100); }
    catch (error) { return (cents / 100).toFixed(2) + ' ' + currency; }
  };

  document.querySelectorAll('[data-product-root]').forEach(section => {
    const form = section.querySelector('.bt-product-form');
    if (!form) return;
    const jsonElement = form.querySelector('[data-variants-json]');
    let variants = [];
    try { variants = JSON.parse(jsonElement.textContent); }
    catch (error) { return; }
    const variantInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-variant-price]');
    const compare = section.querySelector('[data-compare-price]');
    const buyButton = form.querySelector('[data-add-to-cart]');
    const buyLabel = form.querySelector('[data-add-to-cart-label]');
    const personalization = form.querySelector('[data-personalization]');
    const optionGroups = [...form.querySelectorAll('[data-option-position]')];

    function syncVariant() {
      const selected = optionGroups.map(group => {
        const active = group.querySelector('input[type="radio"]:checked');
        const label = group.querySelector('[data-option-current]');
        if (label && active) label.textContent = active.value;
        return active ? active.value : '';
      });
      let variant;
      if (optionGroups.length) variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
      else variant = variants.find(item => String(item.id) === variantInput.value) || variants[0];
      if (!variant) {
        if (buyButton) buyButton.disabled = true;
        if (buyLabel) buyLabel.textContent = 'Selection unavailable';
        return;
      }
      variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = formatMoney(variant.compare_at_price);
      }
      const available = Boolean(variant.available);
      if (buyButton) buyButton.disabled = !available;
      if (buyLabel) buyLabel.textContent = available ? (section.hasAttribute('data-avvio-preorder') ? 'PRE-ORDER NOW' : 'Add to selection') : 'Currently unavailable';
      if (personalization) {
        const personalOption = (variant.title || '').toLowerCase();
        const show = personalOption.includes('initial') || personalOption.includes('logo') || personalOption.includes('personal');
        personalization.hidden = !show;
        const input = personalization.querySelector('input');
        if (input) input.disabled = !show;
      }
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', newUrl.pathname + newUrl.search + newUrl.hash);
    }

    optionGroups.forEach(group => group.querySelectorAll('[data-option-value]').forEach(input => input.addEventListener('change', syncVariant)));
    if (variants.length) syncVariant();

    section.querySelectorAll('[data-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        const main = section.querySelector('[data-main-media] img');
        if (!main) return;
        main.src = button.dataset.fullUrl;
        main.removeAttribute('srcset');
        main.alt = button.dataset.imageAlt || '';
        const viewImage = section.querySelector('[data-v5-view-image]');
        if (viewImage) { viewImage.href = button.dataset.zoomUrl || button.dataset.fullUrl; viewImage.setAttribute('aria-label','View full image of '+(button.dataset.imageAlt || 'this product')); }
        section.querySelectorAll('[data-thumb]').forEach(thumb => {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
      });
    });

    form.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.addEventListener('click', () => {
        const quantity = form.querySelector('[data-quantity]');
        if (!quantity) return;
        const amount = Number.parseInt(quantity.value || '1', 10);
        quantity.value = Math.max(1, amount + Number.parseInt(button.dataset.quantityChange, 10));
      });
    });
  });
})();

(() => {
  'use strict';
  const root = document.querySelector('[data-bh-header]');
  if (!root) return;
  const menu = root.querySelector('#BhMenu');
  const openBtn = root.querySelector('[data-bh-menu-trigger]');
  const closeBtn = root.querySelector('[data-bh-menu-close]');
  if (!menu || !openBtn) return;
  const toggle = (show) => {
    menu.classList.toggle('is-open', show);
    openBtn.setAttribute('aria-expanded', String(show));
    menu.setAttribute('aria-hidden', String(!show));
    menu.inert = !show;
    if (show) { closeBtn?.focus(); }
    else { openBtn.focus(); }
  };
  openBtn.addEventListener('click', () => toggle(openBtn.getAttribute('aria-expanded') !== 'true'));
  closeBtn?.addEventListener('click', () => toggle(false));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.classList.contains('is-open')) toggle(false); });
  document.addEventListener('click', event => { if (menu.classList.contains('is-open') && !root.contains(event.target)) toggle(false); });
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); menu.inert = true; openBtn.setAttribute('aria-expanded','false'); }));
})();

(() => {
  'use strict';
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isEditor = Boolean(window.Shopify && window.Shopify.designMode);

  function initHeader(scope = document) {
    const header = scope.querySelector('[data-v4-header]');
    if (!header || header.dataset.v4Ready) return;
    header.dataset.v4Ready = '1';
    const menu = header.querySelector('[data-v4-menu]');
    const openBtn = header.querySelector('[data-v4-menu-open]');
    const closeBtn = header.querySelector('[data-v4-menu-close]');
    if (!menu || !openBtn || !closeBtn) return;
    let previousFocus = null;
    const tabbables = () => [...menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')].filter(el => el.getClientRects().length);
    function closeMenu(restoreFocus = true) {
      if (!menu.classList.contains('is-visible')) return;
      menu.classList.remove('is-visible');
      header.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      menu.inert = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('v4-nav-open');
      if (restoreFocus && previousFocus instanceof HTMLElement) previousFocus.focus();
    }
    function openMenu() {
      previousFocus = document.activeElement;
      menu.inert = false;
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-visible');
      header.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('v4-nav-open');
      window.setTimeout(() => { if (menu.classList.contains('is-visible')) closeBtn.focus({preventScroll:true}); }, 260);
    }
    openBtn.addEventListener('click', () => menu.classList.contains('is-visible') ? closeMenu() : openMenu());
    closeBtn.addEventListener('click', () => closeMenu());
    menu.addEventListener('click', ev => { if (ev.target.closest('a[href]')) closeMenu(false); });
    document.addEventListener('keydown', ev => {
      if (!menu.classList.contains('is-visible')) return;
      if (ev.key === 'Escape') { ev.preventDefault(); closeMenu(); return; }
      if (ev.key !== 'Tab') return;
      const nodes = tabbables();
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    });
    let raf = false;
    function updateHeader() {
      header.classList.toggle('is-scrolled', window.scrollY > 64);
      raf = false;
    }
    window.addEventListener('scroll', () => {
      if (!raf) { raf = true; requestAnimationFrame(updateHeader); }
    }, {passive:true});
    updateHeader();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(header)) document.body.classList.remove('v4-nav-open');
    });
  }

  function initIntro(scope = document) {
    const intro = scope.querySelector('[data-v4-intro]');
    if (!intro || intro.dataset.v4Ready) return;
    intro.dataset.v4Ready = '1';
    let skip = prefersReducedMotion() || isEditor;
    try { skip = skip || sessionStorage.getItem('buton-v4-seen') === '1'; } catch (_) {}
    if (skip) { intro.hidden = true; return; }
    try { sessionStorage.setItem('buton-v4-seen','1'); } catch (_) {}
    window.setTimeout(() => { intro.hidden = true; }, 1950);
  }


  function initHero(scope = document) {
    const stage = scope.querySelector('[data-v4-tilt]');
    if (!stage || stage.dataset.v4Ready) return;
    stage.dataset.v4Ready = '1';
    if (prefersReducedMotion() || !window.matchMedia('(pointer:fine)').matches) return;
    const orbit = stage.querySelector('.v4-entrance__orbit');
    const watch = stage.querySelector('.v4-entrance__image-shell');
    if (!orbit || !watch) return;
    let frame = 0;
    stage.addEventListener('pointermove', event => {
      if (frame) cancelAnimationFrame(frame);
      const x = event.clientX, y = event.clientY;
      frame = requestAnimationFrame(() => {
        const box = stage.getBoundingClientRect();
        const nx = (x - box.left) / box.width - .5;
        const ny = (y - box.top) / box.height - .5;
        orbit.style.setProperty('--v4-orbit-x', (nx * 28).toFixed(2) + 'px');
        orbit.style.setProperty('--v4-orbit-y', (ny * 24).toFixed(2) + 'px');
        watch.style.setProperty('--v4-watch-x', (nx * -8).toFixed(2) + 'px');
        watch.style.setProperty('--v4-watch-y', (ny * -8).toFixed(2) + 'px');
      });
    }, {passive:true});
    stage.addEventListener('pointerleave', () => {
      if (frame) cancelAnimationFrame(frame);
      orbit.style.setProperty('--v4-orbit-x', '0px');
      orbit.style.setProperty('--v4-orbit-y', '0px');
      watch.style.setProperty('--v4-watch-x', '0px');
      watch.style.setProperty('--v4-watch-y', '0px');
    });
  }

  function initAtlas(scope = document) {
    scope.querySelectorAll('[data-v4-atlas]').forEach(atlas => {
      if (atlas.dataset.v4Ready) return;
      atlas.dataset.v4Ready = '1';
      const viewport = atlas.querySelector('[data-v4-atlas-viewport]');
      const prev = atlas.querySelector('[data-v4-atlas-prev]');
      const next = atlas.querySelector('[data-v4-atlas-next]');
      if (!viewport || !prev || !next) return;
      const move = direction => {
        const slide = viewport.querySelector('.v4-atlas__item');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(viewport).gap) || 0;
        viewport.scrollBy({left: direction * (slide.getBoundingClientRect().width + gap),behavior:prefersReducedMotion() ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      function update() {
        const leadingInset = Number.parseFloat(getComputedStyle(viewport).paddingLeft) || 0;
        prev.disabled = viewport.scrollLeft <= leadingInset + 3;
        next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 3;
        prev.setAttribute('aria-disabled', String(prev.disabled));
        next.setAttribute('aria-disabled', String(next.disabled));
      }
      viewport.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    });
  }

  function initReveals(scope = document) {
    const nodes = [...scope.querySelectorAll('.v4-reveal:not([data-v4-reveal-init])')];
    if (!nodes.length) return;
    nodes.forEach(node => { node.dataset.v4RevealInit = '1'; });
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      nodes.forEach(node => node.classList.add('is-visible'));
      return;
    }
    document.documentElement.classList.add('v4-motion');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {rootMargin:'0px 0px -45px 0px',threshold:0.04});
    nodes.forEach(node => observer.observe(node));
  }

  function initProgress() {
    const bar = document.querySelector('[data-v4-progress]');
    if (!bar) return;
    let queued = false;
    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = `scaleX(${max > 0 ? Math.min(1, window.scrollY/max) : 0})`;
      queued = false;
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  }

  function init(scope = document) {
    initHeader(scope);
    initIntro(scope);
    initHero(scope);
    initAtlas(scope);
    initReveals(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(); initProgress(); }, {once:true});
  else { init(); initProgress(); }
  document.addEventListener('shopify:section:load', ev => init(ev.target));
})();

(() => {
'use strict';
const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
function initNavigation(scope = document) {
  const header = scope.querySelector('[data-v5-header]');
  if (!header || header.dataset.v5Ready) return;
  header.dataset.v5Ready = '1';
  const dialog = header.querySelector('[data-v5-menu]');
  const opener = header.querySelector('[data-v5-menu-open]');
  const closer = header.querySelector('[data-v5-menu-close]');
  if (!dialog || !opener || !closer) return;

  let closingTimer = null;
  let pendingDestination = null;
  let restoreOpener = true;
  let scheduled = false;

  const syncClose = () => {
    document.body.classList.remove('v5-menu-open');
    opener.setAttribute('aria-expanded', 'false');
    dialog.removeAttribute('data-bt5-opening');
    dialog.removeAttribute('data-bt5-closing');
    clearTimeout(closingTimer);
    closingTimer = null;
    if (restoreOpener && opener.isConnected) opener.focus({ preventScroll: true });
    restoreOpener = true;
    const destination = pendingDestination;
    pendingDestination = null;
    if (destination) window.location.assign(destination);
  };

  const finishClose = () => {
    if (!dialog.open) return;
    dialog.close();
  };

  const closeMenu = (opts = {}) => {
    if (!dialog.open) return;
    if (dialog.hasAttribute('data-bt5-closing')) return;
    restoreOpener = opts.restoreFocus !== false;
    pendingDestination = opts.follow || null;
    if (reduce()) {
      finishClose();
      return;
    }
    dialog.removeAttribute('data-bt5-opening');
    dialog.setAttribute('data-bt5-closing', '');
    closingTimer = window.setTimeout(finishClose, 425);
  };

  const show = () => {
    if (dialog.open) return;
    clearTimeout(closingTimer);
    pendingDestination = null;
    restoreOpener = true;
    const bounds = opener.getBoundingClientRect();
    dialog.style.setProperty('--bt5-menu-x', `${Math.round(bounds.left + bounds.width * 0.28)}px`);
    dialog.style.setProperty('--bt5-menu-y', `${Math.round(bounds.top + bounds.height * 0.5)}px`);
    dialog.removeAttribute('data-bt5-closing');
    dialog.setAttribute('data-bt5-opening', '');
    dialog.showModal();
    document.body.classList.add('v5-menu-open');
    opener.setAttribute('aria-expanded', 'true');
    closer.focus({ preventScroll: true });
  };

  opener.addEventListener('click', show);
  closer.addEventListener('click', () => closeMenu());
  dialog.addEventListener('close', syncClose);
  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    closeMenu();
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) { closeMenu(); return; }
    const link = event.target.closest('a[href]');
    if (!link || !dialog.contains(link)) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    let target;
    try { target = new URL(link.href, window.location.href); } catch (error) { return; }
    if (target.origin !== window.location.origin || !/^https?:$/.test(target.protocol)) {
      closeMenu({ restoreFocus: false });
      return;
    }
    if (window.matchMedia('(max-width:760px)').matches) {
      closeMenu({ restoreFocus: false });
      return;
    }
    event.preventDefault();
    closeMenu({ restoreFocus: false, follow: target.href });
  });

  const onScroll = () => {
    header.classList.toggle('v5-header--scrolled', window.scrollY > 72);
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();
  header.addEventListener('shopify:section:unload', () => {
    clearTimeout(closingTimer);
    pendingDestination = null;
    if (dialog.open) dialog.close();
  });
}
function initZoom() {
  const dialog = document.querySelector('[data-v5-lightbox]');
  if (!dialog || dialog.dataset.v5Ready) return;
  dialog.dataset.v5Ready = '1';
  const image = dialog.querySelector('[data-v5-lightbox-image]');
  const range = dialog.querySelector('[data-v5-zoom-range]');
  let previous = null;
  document.addEventListener('click',event=>{
    const control=event.target.closest('[data-v5-zoom-open]');
    if(!control||dialog.open)return;
    const src=control.dataset.v5ZoomSrc;
    if(!src)return;
    previous=control;
    image.src=src;
    image.alt=control.dataset.v5ZoomAlt||'Watch photograph';
    range.value='100';
    dialog.showModal();
    document.body.classList.add('v5-lightbox-open');
    dialog.querySelector('[data-v5-lightbox-close]')?.focus({preventScroll:true});
  });
  dialog.querySelector('[data-v5-lightbox-close]')?.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  dialog.addEventListener('close',()=>{
    document.body.classList.remove('v5-lightbox-open');
    image.removeAttribute('src');
    previous?.focus({preventScroll:true});
  });
}
function initReveal(scope=document){
 const nodes=scope.querySelectorAll('[data-v5-reveal]:not([data-v5-observed])');
 if(!nodes.length)return;
 if(reduce() || !('IntersectionObserver' in window)){nodes.forEach(el=>el.classList.add('v5-is-visible'));return;}
 document.documentElement.classList.add('v5-motion-ready');
 const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('v5-is-visible');io.unobserve(entry.target);}}),{threshold:.08,rootMargin:'0px 0px -20px 0px'});
 nodes.forEach(el=>{el.dataset.v5Observed='true';io.observe(el);});
}
function init(){initNavigation();initZoom();initReveal();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',event=>{initNavigation(event.target);initReveal(event.target);});
})();

(() => {
  'use strict';
  function initSignature(scope=document) {
    scope.querySelectorAll('[data-sig-stage]').forEach(stage => {
      if (stage.dataset.sigReady) return;
      stage.dataset.sigReady='1';
      const buttons=[...stage.querySelectorAll('[data-sig-select]')];
      const pieces=[...stage.querySelectorAll('[data-sig-piece]')];
      const choose = id => {
        buttons.forEach(button => {
          const active=button.dataset.sigSelect===id;
          button.classList.toggle('is-current',active);
          button.setAttribute('aria-pressed',String(active));
        });
        pieces.forEach(piece=>{
          const active=piece.dataset.sigPiece===id;
          piece.hidden=!active;
          piece.classList.toggle('is-current',active);
        });
      };
      buttons.forEach(button=>button.addEventListener('click',()=>choose(button.dataset.sigSelect)));
      if (buttons.length) choose(buttons[0].dataset.sigSelect);
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initSignature(),{once:true});
  else initSignature();
  document.addEventListener('shopify:section:load',event=>initSignature(event.target));
})();

(() => {
  'use strict';
  function privateConsultations(scope=document){
    const modal=scope.querySelector('[data-bhx-private]');
    if(!modal || modal.dataset.bhxReady)return;
    modal.dataset.bhxReady='1';
    const btn=scope.querySelector('[data-bhx-private-open]');
    const close=modal.querySelector('[data-bhx-private-close]');
    const variantInput=modal.querySelector('[data-bhx-private-variant]');
    const product=scope.querySelector('[data-product-root]');
    let lastFocus=null;
    const open=()=>{
      if(modal.open)return;
      lastFocus=document.activeElement;
      if(variantInput && product){
        const picked=[...product.querySelectorAll('[data-option-position]')].map(group=>group.querySelector('input:checked')?.value).filter(Boolean).join(' / ');
        if(picked)variantInput.value=picked;
      }
      modal.showModal();
      close?.focus({preventScroll:true});
    };
    btn?.addEventListener('click',open);
    close?.addEventListener('click',()=>modal.close());
    modal.addEventListener('click',event=>{if(event.target===modal)modal.close();});
    modal.addEventListener('close',()=>{if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});});
    if(modal.querySelector('[data-bhx-autoshow]'))open();
  }
  function contactContext(scope=document){
    const form=scope.querySelector('[data-bhx-contact]');
    if(!form || form.dataset.bhxReady)return;
    form.dataset.bhxReady='1';
    const params=new URLSearchParams(window.location.search);
    const s=params.get('subject');
    const field=form.querySelector('[data-bhx-contact-subject]');
    if(s && field){const v=[...field.options].find(x=>x.value.toLowerCase()===s.toLowerCase());if(v)field.value=v.value;}
    const ref=params.get('reference');
    const msg=form.querySelector('textarea[name="contact[body]"]');
    if(ref && msg && !msg.value)msg.value='I would like to discuss '+ref+'.';
  }
  function backgroundFilm(scope=document){
    scope.querySelectorAll('[data-bhx-film]:not([data-bhx-ready])').forEach(film=>{
      film.dataset.bhxReady='1';
      const video=film.querySelector('video');
      if(!video)return;
      const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const save=!!navigator.connection?.saveData;
      if(reduce || save){video.pause();return;}
      video.muted=true;
      video.playsInline=true;
      if('IntersectionObserver' in window){
        const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting && document.visibilityState==='visible')video.play().catch(()=>{});else video.pause();}),{threshold:.2});
        io.observe(film);
        document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')video.pause();});
      } else video.play().catch(()=>{});
    });
  }
  function init(scope=document){privateConsultations(scope);contactContext(scope);backgroundFilm(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


(() => {
 'use strict';
 function connect(scope=document){
   scope.querySelectorAll('[data-bv7-cinema]:not([data-bv7-connected])').forEach(root=>{
     root.dataset.bv7Connected='true';
     const player=root.querySelector('[data-bv7-cinema-film] video');
     const button=root.querySelector('[data-bv7-cinema-toggle]');
     if(!player || !button)return;
     const reduced=matchMedia('(prefers-reduced-motion: reduce)');
     const saveData=!!navigator.connection?.saveData;
     let userPaused=false;
     let inView=false;
     const label=button.querySelector('[data-bv7-cinema-label]');
     const refresh=()=>{
       const shouldPlay=inView && !userPaused && !saveData && !reduced.matches && !document.hidden;
       if(shouldPlay){player.muted=true;player.playsInline=true;player.play().catch(()=>{});}else player.pause();
       button.setAttribute('aria-pressed',String(userPaused));
       if(label)label.textContent=userPaused?'RESUME MOTION':'PAUSE MOTION';
       button.hidden=saveData || reduced.matches;
     };
     button.addEventListener('click',()=>{userPaused=!userPaused;refresh();});
     if('IntersectionObserver' in window){
       const io=new IntersectionObserver(entries=>{inView=entries[0]?.isIntersecting||false;refresh();},{threshold:.2});
       io.observe(root);
     }else{inView=true;refresh();}
     document.addEventListener('visibilitychange',refresh);
     reduced.addEventListener?.('change',refresh);
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>connect(),{once:true});else connect();
 document.addEventListener('shopify:section:load',event=>connect(event.target));
})();

(() => {
 'use strict';
 const doc = document.documentElement;
 const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 function initOpening(scope=document){
  const intro=scope.querySelector('[data-v8-opening]');
  if(!intro || intro.dataset.v13IntroReady)return;
  intro.dataset.v13IntroReady='true';
  const skip=intro.querySelector('[data-v8-skip]');
  const doc=document.documentElement;
  const explicit=()=>doc.classList.contains('v13-force-motion');
  const limited=()=>reduce()&&!explicit();
  let durationTimer=null,exitTimer=null,active=false,priorFocus=null;
  const finish=()=>{
    if(!active)return;
    active=false;
    clearTimeout(durationTimer);
    doc.classList.remove('v13-intro-paused');
    try{sessionStorage.setItem('buton-v13-motionfix-welcomed','1')}catch(error){}
    doc.classList.add('v11-intro-reveal');
    intro.classList.add('is-leaving');
    exitTimer=window.setTimeout(()=>{
      doc.classList.remove('v8-intro-armed','v11-intro-reveal','v13-static-intro','v13-intro-paused');
      intro.hidden=true;
      if(priorFocus?.isConnected&&priorFocus!==document.body)priorFocus.focus({preventScroll:true});
    },limited()?30:970);
  };
  const startWhenVisible=()=>{
    clearTimeout(durationTimer);
    durationTimer=null;
    if(!active)return;
    if(document.hidden){doc.classList.add('v13-intro-paused');return;}
    doc.classList.remove('v13-intro-paused');
    skip?.focus({preventScroll:true});
    durationTimer=window.setTimeout(finish,limited()?2400:3550);
  };
  const play=(manual=false)=>{
    if(!manual&&!doc.classList.contains('v8-intro-armed')){
      intro.hidden=true;
      doc.classList.remove('v8-intro-armed','v13-intro-paused');
      return;
    }
    clearTimeout(durationTimer);
    clearTimeout(exitTimer);
    priorFocus=manual?document.activeElement:null;
    active=true;
    doc.classList.remove('v11-intro-reveal','v13-static-intro');
    if(limited())doc.classList.add('v13-static-intro');
    intro.hidden=false;
    intro.classList.remove('is-leaving');
    doc.classList.add('v8-intro-armed');
    intro.classList.add('v13-restart');
    void intro.offsetWidth;
    intro.classList.remove('v13-restart');
    startWhenVisible();
  };
  skip?.addEventListener('click',finish);
  intro.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();finish()}});
  document.addEventListener('buton:replay-intro',()=>play(true));
  document.addEventListener('visibilitychange',()=>{if(active)startWhenVisible()});
  play();
 }
 function initHero(scope=document){
  const hero=scope.querySelector('[data-v8-hero]');
  if(!hero || hero.dataset.v8Ready)return;
  hero.dataset.v8Ready='true';
  if(reduce() || !window.matchMedia('(pointer:fine)').matches)return;
  const area=hero.querySelector('[data-v8-object]');
  if(!area)return;
  let next=0;
  const reset=()=>{area.style.setProperty('--v8-obj-x','0px');area.style.setProperty('--v8-obj-y','0px')};
  area.addEventListener('pointermove', e=>{
   if(next)cancelAnimationFrame(next);
   next=requestAnimationFrame(()=>{
    const b=area.getBoundingClientRect();
    const dx=(e.clientX-b.left)/b.width-.5,dy=(e.clientY-b.top)/b.height-.5;
    area.style.setProperty('--v8-obj-x',Math.round(dx*12)+'px');
    area.style.setProperty('--v8-obj-y',Math.round(dy*9)+'px');
   });
  },{passive:true});
  area.addEventListener('pointerleave',reset);
 }
 function initMotion(scope=document){
  const sections=[...scope.querySelectorAll('[data-v8-editorial]')];
  if(reduce() || !('IntersectionObserver' in window)){sections.forEach(s=>s.classList.add('is-visible'));return;}
  if(sections.length)doc.classList.add('v8-motion-ready');
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.14,rootMargin:'0px 0px -20px 0px'});
  sections.forEach(s=>{if(s.dataset.v8Observed)return;s.dataset.v8Observed='true';observer.observe(s)});
 }
 function initVideos(scope=document){
  const videoWraps=[...scope.querySelectorAll('[data-v8-video]')];
  if(!videoWraps.length)return;
  const saveData=navigator.connection?.saveData;
  if(reduce() || saveData)return;
  const play=el=>{const v=el.querySelector('video');if(!v || el.dataset.v11FilmPaused==='true')return;v.muted=true;v.playsInline=true;v.preload='metadata';const result=v.play();if(result && result.catch)result.catch(()=>{})};
  const pause=el=>{const v=el.querySelector('video');if(v && !v.paused)v.pause()};
  if(!('IntersectionObserver' in window))return;
  const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.isIntersecting?play(entry.target):pause(entry.target))},{threshold:.18});
  videoWraps.forEach(el=>{if(el.dataset.v8VideoReady)return;el.dataset.v8VideoReady='true';obs.observe(el)});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)videoWraps.forEach(pause)}, {passive:true});
 }
 const init=scope=>{initOpening(scope);initHero(scope);initMotion(scope);initVideos(scope)};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();


(() => {
  'use strict';
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mounted = new WeakSet();
  function acquisition(){
    const modal=document.querySelector('[data-v9-suite]');
    if(!modal || mounted.has(modal))return;
    mounted.add(modal);
    const enabled = modal.dataset.v9Enabled === 'true';
    const openerSelector = '[data-v9-acquire-open]';
    const closer=modal.querySelector('[data-v9-suite-close]');
    let source=null;
    document.addEventListener('click', e=>{
      const element=e.target.closest(openerSelector);
      if(!element || !enabled || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || element.target==='_blank')return;
      if(typeof modal.showModal!=='function')return;
      e.preventDefault();
      source=element;
      if(!modal.open){modal.showModal();document.body.classList.add('v9-suite-open');closer?.focus({preventScroll:true});}
    });
    closer?.addEventListener('click',()=>modal.close());
    modal.addEventListener('click',e=>{if(e.target===modal)modal.close();});
    modal.addEventListener('close',()=>{document.body.classList.remove('v9-suite-open');source?.focus({preventScroll:true});});
  }
  function macro(){
    const modal=document.querySelector('[data-v5-lightbox]');
    if(!modal || mounted.has(modal))return;
    mounted.add(modal);
    const canvas=modal.querySelector('.v5-lightbox__canvas');
    const img=modal.querySelector('[data-v5-lightbox-image]');
    const range=modal.querySelector('[data-v5-zoom-range]');
    const label=modal.querySelector('[data-v5-zoom-label]');
    if(!canvas||!img||!range||!label)return;
    const pts=new Map();let panX=0,panY=0, previous=null, isDrag=false;
    let zoom=Number(range.value)/100;
    const bound=()=>{const b=canvas.getBoundingClientRect();const maxX=(b.width*(zoom-1))/2,maxY=(b.height*(zoom-1))/2;panX=Math.min(maxX,Math.max(-maxX,panX));panY=Math.min(maxY,Math.max(-maxY,panY));};
    const paint=()=>{bound();img.style.setProperty('--v5-zoom',String(zoom));img.style.setProperty('--v9-pan-x',panX+'px');img.style.setProperty('--v9-pan-y',panY+'px');range.value=String(Math.round(zoom*100));label.textContent=Math.round(zoom*100)+'%';};
    const distance=arr=>Math.hypot(arr[0].x-arr[1].x,arr[0].y-arr[1].y);
    range.addEventListener('input',()=>{zoom=Math.min(3.5,Math.max(1,Number(range.value)/100));paint();});
    canvas.addEventListener('pointerdown',e=>{
      if(!modal.open || e.button!==0 && e.pointerType==='mouse')return;
      e.preventDefault();
      canvas.setPointerCapture?.(e.pointerId);
      pts.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(pts.size===1){isDrag=true;previous={x:e.clientX,y:e.clientY};}
      else{isDrag=false;previous=null;}
    });
    canvas.addEventListener('pointermove',e=>{
      if(!pts.has(e.pointerId) || !modal.open)return;
      e.preventDefault();
      const points=[...pts.values()];const oldDist=points.length===2?distance(points):0;
      pts.set(e.pointerId,{x:e.clientX,y:e.clientY});
      const next=[...pts.values()];
      if(next.length===2 && oldDist>10){zoom=Math.max(1,Math.min(3.5,zoom*distance(next)/oldDist));paint();}
      else if(next.length===1 && isDrag && previous && zoom>1){panX+=e.clientX-previous.x;panY+=e.clientY-previous.y;paint();}
      previous=next.length===1?{x:e.clientX,y:e.clientY}:null;
    });
    const finish=e=>{pts.delete(e.pointerId);if(pts.size===1){const one=[...pts.values()][0];previous={x:one.x,y:one.y};isDrag=true;}else{previous=null;isDrag=false;}};
    canvas.addEventListener('pointerup',finish);canvas.addEventListener('pointercancel',finish);canvas.addEventListener('lostpointercapture',finish);
    canvas.addEventListener('dblclick',e=>{e.preventDefault();zoom=zoom>1?1:2.4;if(zoom===1)panX=panY=0;paint();});
    modal.addEventListener('close',()=>{zoom=1;panX=panY=0;pts.clear();paint();});
    paint();
  }
  function chamber(scope=document){
    scope.querySelectorAll('[data-v9-chamber]').forEach(ch=>{
      if(mounted.has(ch))return;mounted.add(ch);
      const media=ch.querySelector('[data-v9-chamber-image]');
      const film=ch.querySelector('[data-v9-chamber-video] video');
      const allowMotion=!reduce()&&document.body.dataset.v9Motion!=='false'&&!navigator.connection?.saveData;
      let visible=false;
      const sync=()=>{if(!film)return;if(allowMotion && visible && !document.hidden && ch.dataset.v11FilmPaused!=='true'){film.playsInline=true;film.muted=true;film.preload='metadata';film.play().catch(()=>{});}else film.pause();};
      if('IntersectionObserver' in window){
        const watcher=new IntersectionObserver(e=>{visible=e[0]?.isIntersecting||false;ch.classList.toggle('v9-chamber--visible',visible);sync();},{threshold:.15});watcher.observe(ch);
      }else{visible=true;ch.classList.add('v9-chamber--visible');sync();}
      document.addEventListener('visibilitychange',sync,{passive:true});
      if(!media || !allowMotion || !window.matchMedia('(pointer:fine)').matches)return;
      let ticking=false;
      media.addEventListener('pointermove',e=>{
        if(ticking)return;ticking=true;
        requestAnimationFrame(()=>{
          const rect=media.getBoundingClientRect();const dx=(e.clientX-rect.left)/rect.width-.5;
          const dy=(e.clientY-rect.top)/rect.height-.5;
          media.style.setProperty('--v9-media-x',Math.round(dx*9)+'px');media.style.setProperty('--v9-media-y',Math.round(dy*7)+'px');ticking=false;
        });
      },{passive:true});
      media.addEventListener('pointerleave',()=>{media.style.setProperty('--v9-media-x','0px');media.style.setProperty('--v9-media-y','0px');});
    });
  }
  function init(scope=document){acquisition();macro();chamber(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
